import { render } from "./ProductDetailsReport.vue?vue&type=template&id=1381d4ed&scoped=true"
import script from "./ProductDetailsReport.vue?vue&type=script&lang=js"
export * from "./ProductDetailsReport.vue?vue&type=script&lang=js"

import "./ProductDetailsReport.vue?vue&type=style&index=0&id=1381d4ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1381d4ed"]])

export default __exports__